import {Component, effect, inject, Renderer2} from '@angular/core';
import {EnvironmentService} from '../../services/environment.service';
import {GOOGLE_TAG_MANAGER, UserCentricsService} from '../../services/user-centrics.service';

@Component({
  selector: 'cov-google-tagmanager',
  imports: [],
  templateUrl: './google-tagmanager.component.html',
  styleUrl: './google-tagmanager.component.scss',
})
export class GoogleTagmanagerComponent {
  private renderer = inject(Renderer2);
  private environmentService = inject(EnvironmentService);
  private userCentricsService = inject(UserCentricsService);

  constructor() {
    effect(() => {
      if (
        this.environmentService.isGoogleTagmanagerEnabled &&
        this.userCentricsService.hasConsent(GOOGLE_TAG_MANAGER)()
      ) {
        this.initialize();
      }
    });
  }

  private initialize() {
    const id = this.environmentService.getGoogleTagmanagerEnvironment();
    const script = this.renderer.createElement('script');
    script.text = `
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://gtm.covestro.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${id}');
    `;
    this.renderer.appendChild(document.head, script);
  }
}
